import { useParams } from 'react-router-dom-v5-compat'

import { GuestRegistryHeader } from 'registry/components/GuestRegistryHeader/GuestRegistryHeader'
import RegistryGiftGiverPageSeo from '../RegistryGiftGiverPageSeo/RegistryGiftGiverPageSeo'
import RegistryBackBannerPortal from '../RegistryBackBannerPortal/RegistryBackBannerPortal'
import useGetRegistry from '../../hooks/useGetRegistry'
import useGetRegItemsMinimal from '../../hooks/useGetRegItemsMinimal'
import css from './RegistryGiftGiverPage.styles.scss'
import useGetSortFilterOptions from '../../hooks/useGetSortFilterOptions'
import useGetReservations from '../../hooks/useGetReservations'
import { useAppliedSortsAndFiltersContext } from '../../contexts'
import {
  getPreviewFilterResultsClosure,
  sortAndFilterRegItems,
} from './RegistryGiftGiverPage.utils'
import RegistryStickyControlsBar from '../RegistryStickyControlsBar/RegistryStickyControlsBar'
import RegistryCategories from '../RegistryCategories/RegistryCategories'
import RegistryBackToTop from '../RegistryBackToTop'
import useGetVisitorReservations from '../../hooks/useGetVisitorReservations'
import { RegistryGiftGiverPageLegacyAdapter } from './RegistryGiftGiverPageLegacyAdapter'

const RegistryGiftGiverPage = () => {
  const { slug } = useParams()
  const { registry } = useGetRegistry(slug)
  const { regItems, regItemsMinimalQuery } = useGetRegItemsMinimal(registry.id)
  const { sortFilterOptions } = useGetSortFilterOptions(registry.id)
  const { reservations, reservationsQuery } = useGetReservations(registry.id)
  const { visitorReservations } = useGetVisitorReservations(registry.id)
  const { appliedSortsAndFilters } = useAppliedSortsAndFiltersContext()
  const previewFilterResults = getPreviewFilterResultsClosure(regItems)
  const sortedAndFilteredRegItems = sortAndFilterRegItems(
    regItems,
    appliedSortsAndFilters
  )
  const currentCategoryIsAll =
    appliedSortsAndFilters.filters?.category === 'All'

  return (
    <RegistryGiftGiverPageLegacyAdapter registry={registry}>
      <div
        className={css.RegistryGiftGiverPage}
        data-testid="RegistryGiftGiverPage"
      >
        <RegistryBackBannerPortal registry={registry} />

        <RegistryGiftGiverPageSeo registry={registry} slug={slug} />

        {registry.title && (
          <GuestRegistryHeader
            arrivalDate={registry.family?.arrivalDate}
            note={registry.description}
            photoUrl={registry.photoUrl}
            registry={registry}
            title={registry.title}
          />
        )}

        <div className={css.RegistryGiftGiverPage__Content}>
          <RegistryStickyControlsBar
            firstNames={registry.firstNames}
            previewFilterResults={previewFilterResults}
            regItems={regItems}
            reservations={reservations}
            sortFilterOptions={sortFilterOptions}
          />

          <RegistryCategories
            isLoadingComplete={
              !reservationsQuery.isLoading && !regItemsMinimalQuery.isLoading
            }
            regItems={sortedAndFilteredRegItems}
            registry={registry}
            reservations={reservations}
            visitorReservations={visitorReservations}
          />
        </div>
        {currentCategoryIsAll && <RegistryBackToTop variant="bottom" />}
        <RegistryBackToTop variant="floating" />
      </div>
    </RegistryGiftGiverPageLegacyAdapter>
  )
}

export default RegistryGiftGiverPage
